<template>
  <div id="sidebar">
    <v-app>
      <v-app-bar app color="primary" dark elevation="0">
        <v-app-bar-nav-icon
          @click.stop="sidebarMenu = !sidebarMenu"
        ></v-app-bar-nav-icon>
        <v-spacer></v-spacer>

        <v-btn @click="logout" color="rounded-card" class="ma-1 white--text"
          ><v-icon left>mdi-account</v-icon> Logout</v-btn
        >
      </v-app-bar>
      <v-navigation-drawer
        v-model="sidebarMenu"
        app
        floating
        :permanent="sidebarMenu"
        :mini-variant.sync="mini"
      >
       
        <v-list-item class="px-2 mb-2"  style="background-color: #006d77" @click="toggleMini = !toggleMini">
          <v-list-item-avatar>
            <v-icon color="#fff" large>mdi-alpha-p-circle</v-icon>
          </v-list-item-avatar>
          <v-list-item-content class="text-truncate px-15" style="font-size:25px; color: #fff; font-weight: bold; margin:5px;">
            PIMS
          </v-list-item-content>
          <v-btn icon small>
            <v-icon color="#fff">mdi-chevron-left</v-icon>
          </v-btn>
        </v-list-item>
        <v-divider></v-divider>
        <v-list>
          <v-list-item
            v-for="item in items"
            :key="item.title"
            :to="{ name: item.link }"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item-icon>
                  <v-icon v-bind="attrs" v-on="on" color="primary">{{
                    item.icon
                  }}</v-icon>
                </v-list-item-icon>
              </template>
              <span>{{ item.tooltip }}</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-list-item-content v-bind="attrs" v-on="on">
                  <v-list-item-title class="primary--text">{{
                    item.title
                  }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <span>{{ item.tooltip }}</span>
            </v-tooltip>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
      <v-main class="px-2 pt-0 main-offset">
        <v-container class="px-0 py-0 mx-0 fill-height" fluid>
          <div class="row fill-height">
            <div class="col">
              <transition name="fade">
                <router-view></router-view>
              </transition>
            </div>
          </div>
        </v-container>
      </v-main>
      <v-footer class="py-3">
        <span class="ml-auto subtitle-2">
          <label class="grey--text mr-2">Powered By: </label>
          {{ developedBy }} &reg;</span
        >

        <span class="ml-auto overline">PIMS &copy; {{ copyRightYear }}</span>
      </v-footer>
    </v-app>
  </div>
</template>


 <script>
import firebase from "firebase";

export default {
  name: "SideBar",
  created() {
    // set the Copy right Year for footer
    this.copyRightYear = this.copyRightYear.split("-")[0];
  },
  computed: {
    mini() {
      return this.$vuetify.breakpoint.smAndDown || this.toggleMini;
    },
  },
  methods: {
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.push("/");
        })
        .catch((error) => {
          alert(error.message);
          this.$router.push("/");
        });
    },
  },

  data: () => ({
    sidebarMenu: true,
    toggleMini: false,
    developedBy: "MITC Students",
    copyRightYear: new Date().toISOString().substr(0, 10),

    items: [
      {
        title: "Home",
        link: "dashboard",
        icon: "mdi-home-outline",
        tooltip: "Home",
      },
      {
        title: "News",
        link: "news",
        icon: "mdi-newspaper-variant-outline",
        tooltip: "News",
      },
      // {
      //   title: "Users",
      //   link: "users",
      //   icon: "mdi-account-outline",
      //   tooltip: "Users",
      // },
      {
        title: "Announcement",
        link: "announcement",
        icon: "mdi-bullhorn-outline",
        tooltip: "Announcement",
      },
      {
        title: "Donation",
        link: "donation",
        icon: "mdi-cash-usd-outline",
        tooltip: "Donation",
      },

      {
        title: "Symptom & Prevent",
        link: "symptom-prevent",
        icon: "mdi-emoticon-sick-outline",
        tooltip: "Symptom & Prevent",
      },
      {
        title: "Question/Answer",
        link: "faqs",
        icon: "mdi-head-question-outline",
        tooltip: "Frequently Asked Questions",
      },
      {
        title: "Reports",
        link: "Reports",
        icon: "mdi-file-chart-outline",
        tooltip: "Reports",
      },
      {
        title: "Positive Actions",
        link: "PositiveActions",
        icon: "mdi-account-group-outline",
        tooltip: "Positive Actions",
      },
      {
        title: "Contact Tracing",
        link: "ContactTracing",
        icon: "mdi-radar",
        tooltip: "Contact Tracing",
      },
    ],
  }),
  props: {
    msg: String,
  },
};
</script>
  